<template>
  <div class="animated fadeIn mt-3" id="report">
    <b-row>
      <b-col>
        <h1 class="text-uppercase font-weight-bold">Liquidaciones</h1>
      </b-col>
      <b-col class="flo">
        <ingresar-liquidacion />
        <b-button class="float-right" variant="primary" @click.prevent="showModal">Ingresar Liquidación</b-button>
      </b-col>
    </b-row>
    <server-table
      :downloadeable="false"
      :column_display="column_display"
      :columns="columns"
      :filterable="filterable"
      :headings="headings"
      :listColumns="listColumns"
      :table-options="tableOptions"
      :url="url"
      @on-loading="loading = $event"
      :action-buttons="action_buttons"
      @on-arrow-right-action="(e) => debug(e)"
    >
      <template slot="total_fob" slot-scope="props">
        {{ props.row.total_fob | currency }}
      </template>

      <template slot="total_exporter" slot-scope="props">
        {{ props.row.total_exporter | currency }}
      </template>

      <template slot="total_mys" slot-scope="props">
        {{ props.row.total_mys | currency }}
      </template>

      <template slot="total_rnp" slot-scope="props">
        {{ props.row.total_rnp | currency }}
      </template>

      <template slot="rnp_per_kg" slot-scope="props"> {{ props.row.rnp_per_kg | currency }} / Kg </template>
    </server-table>
  </div>
</template>
<script>
import ServerTable from "../../../bagno_views/ServerFilterableTable.vue";
import IngresarLiquidacion from "./IngresarLiquidacion.vue";
export default {
  name: "Liquidaciones",
  components: {
    ServerTable,
    IngresarLiquidacion
  },
  filters: {
    currency: function (value) {
      // Internationalization of currency
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD"
      }).format(value);
    }
  },
  data() {
    return {
      loading: false,
      action_buttons: ["arrow-right"],
      columns: [
        "shipment__boarding_number",
        "liquidation__date",
        "container__name",
        "container__sku",
        "total_boxes",
        "total_kg",
        "total_fob",
        "total_exporter",
        "total_mys",
        "total_rnp",
        "rnp_per_kg",
        "actions"
      ],
      filterable: [],
      headings: {},
      listColumns: {},
      tableOptions: {
        skin: "table table-sm table-striped table-hover fixed",
        columnsDisplay: {
          // mobile (x < 480)
          // mobileP (x < 320)
          // mobileL (320 <= x < 480)
          // tablet (480 <= x < 1024)
          // tabletP (480 <= x < 768)
          // tabletL (768 <= x < 1024)
          // desktop (1024 <= x < 1280)
          // desktopLarge (1280 <= x < 1920)
          // desktopHuge (x >= 1920)
          // All options can be preceded by the logical operators min,max, and not followed by an underscore.
          // For example, a column which is set to not_mobile will be shown when
          // the width of the window is greater than or equal to 480px,
          // while a column set to max_tabletP will only be shown when the width is under 768px

          shipment__boarding_number: "desktop",
          liquidation__date: "desktop",
          container__name: "desktop",
          container__sku: "desktop"
        },
        columnsClasses: {
          shipment__boarding_number: "text-left",
          liquidation__date: "text-center",
          container__name: "text-center",
          container__sku: "text-center",
          total_boxes: "text-center",
          total_kg: "text-center",
          total_fob: "text-center",
          total_exporter: "text-center",
          total_mys: "text-center",
          total_rnp: "text-center",
          rnp_per_kg: "text-center",
          actions: "text-center w-5"
        },
        headings: {
          shipment__boarding_number: "Embarque",
          liquidation__date: "Fecha",
          container__name: "Contenedor",
          container__sku: "SKU",
          total_boxes: "Cajas",
          total_kg: "Kg",
          total_fob: "FOB",
          total_exporter: "% Exportadora",
          total_mys: "M&S",
          total_rnp: "RNP",
          rnp_per_kg: "RNP/Kg",
          actions: ""
        }
      }
    };
  },
  computed: {
    url() {
      return "/api/comex/groweradvancesummary/detailed/";
    }
  },
  methods: {
    debug(e) {
      console.log(e);
    },
    showModal() {
      this.$bvModal.show("ingresar-liquidacion");
    }
  }
};
</script>
<style></style>
